import { lazy } from 'react'

export const WhatToDoVariant1 = lazy(() => import('./WhatToDoVariant1'))
